<script setup lang="ts">
import Button from 'primevue/button';
import { useAppConfigStore } from '../stores/app-config-store';
import { computed } from 'vue';

const configStore = useAppConfigStore();

const decreaseDisabled = computed(
    () => configStore.scale <= configStore.minScale
);
const increaseDisabled = computed(
    () => configStore.scale >= configStore.maxScale
);

function isSelectedScale(value: number) {
    return Math.abs(value - configStore.scale) < configStore.scaleStep / 2;
}
</script>

<template>
    <div class="app-scale-select flex align-items-center">
        <Button
            icon="pi pi-minus"
            type="button"
            class="p-button-text p-button-rounded w-2rem h-2rem mr-2 mb-2"
            :disabled="decreaseDisabled"
            @click="configStore.decreaseScale()"
        />
        <div class="flex gap-2 align-items-center">
            <i
                v-for="s in configStore.scales"
                :key="s"
                class="pi pi-circle-fill text-300"
                :class="{ 'text-primary-500': isSelectedScale(s) }"
                @click="configStore.setScale(s)"
            ></i>
        </div>
        <Button
            icon="pi pi-plus"
            type="button"
            class="p-button-text p-button-rounded w-2rem h-2rem ml-2 mb-2"
            :disabled="increaseDisabled"
            @click="configStore.increaseScale()"
        />
    </div>
</template>
